module.exports = __webpack_public_path__ + "img/masthead2.a2e6a1d5.jpg";